<template>
  <v-card class="d-flex flex-column justify-space-between">
    <v-card-text>
      <div>
        <h2 class="mb-6 text-uppercase text-center">
          Enterprise
        </h2>
        <h4 class="mb-2">
          Unlimited Users, Credits and Storage
        </h4>
        <p>Premium business features plus:</p>
        <ul class="mb-6">
          <li>
            Generate on behalf of Clients (Professional Service Providers)
          </li>
          <li>Consolidated registry view by entity/project</li>
          <li>
            Delegated access to Client Registers (trusted external delegates)
          </li>
          <li>Enterprise automation projects</li>
          <li>Enterprise &amp; group reporting</li>
          <li>User permissions to reflect internal delegations register</li>
        </ul>
        <p />
      </div>
    </v-card-text>
    <v-card-actions class="d-flex justify-space-around">
      <support-link
        button
        subject="AuthentiGate enterprise subscription"
      >
        Contact us
      </support-link>
    </v-card-actions>
  </v-card>
</template>
<script>
import SupportLink from './SupportLink.vue'
export default {
  name: 'EnterpriseSubscriptionPlan',
  components: { SupportLink }
}
</script>
<style lang="sss" scoped></style>
